import { isPointerInEmailBuilderCanvasDropZone } from './pointer-guard';

const MAIN_CANVAS_ID = 'main-canvas';

const EDGE_THRESHOLD_RATIO = 0.2;
const MAX_SCROLL_SPEED_PX = 22;

function computeVerticalScrollDelta(
  pointerY: number,
  containerTop: number,
  containerHeight: number,
): number {
  const threshold = Math.max(containerHeight * EDGE_THRESHOLD_RATIO, 1);
  const topZoneEnd = containerTop + threshold;
  const bottomZoneStart = containerTop + containerHeight - threshold;

  if (pointerY < topZoneEnd) {
    const depth = (topZoneEnd - pointerY) / threshold;
    return -MAX_SCROLL_SPEED_PX * Math.min(1, Math.max(0, depth));
  }

  if (pointerY > bottomZoneStart) {
    const depth = (pointerY - bottomZoneStart) / threshold;
    return MAX_SCROLL_SPEED_PX * Math.min(1, Math.max(0, depth));
  }

  return 0;
}

export function applyEditorDragVerticalAutoScroll(pointer: {
  x: number;
  y: number;
}): boolean {
  if (!isPointerInEmailBuilderCanvasDropZone(pointer)) {
    return false;
  }

  const scrollRoot = globalThis.document.getElementById(MAIN_CANVAS_ID);
  if (!(scrollRoot instanceof HTMLElement)) {
    return false;
  }
  if (scrollRoot.scrollHeight <= scrollRoot.clientHeight) {
    return false;
  }

  const rect = scrollRoot.getBoundingClientRect();
  const delta = computeVerticalScrollDelta(pointer.y, rect.top, rect.height);
  if (delta === 0) {
    return false;
  }

  const maxScrollTop = scrollRoot.scrollHeight - scrollRoot.clientHeight;
  const previousScrollTop = scrollRoot.scrollTop;
  scrollRoot.scrollTop = Math.max(0, Math.min(maxScrollTop, previousScrollTop + delta));
  return scrollRoot.scrollTop !== previousScrollTop;
}
